import { useEffect, useState } from 'react'

/**
 * Name of the DOM event the Atlas start config (ui/src/index.html) dispatches
 * whenever the chat window opens or closes; keep the two in sync.
 */
export const ATLAS_CHAT_VISIBILITY_EVENT = 'atlas:chat-window-visibility'

/** Whether the Atlas support chat window is currently open. */
export function useAtlasChatOpen() {
  const [open, setOpen] = useState(false)
  useEffect(() => {
    const onVisibility = (event: Event) => {
      setOpen(Boolean((event as CustomEvent).detail?.visible))
    }
    window.addEventListener(ATLAS_CHAT_VISIBILITY_EVENT, onVisibility)
    return () => {
      window.removeEventListener(ATLAS_CHAT_VISIBILITY_EVENT, onVisibility)
    }
  }, [])
  return open
}
